import { createStore } from "vuex";
import Auth from "./auth/user";

export default createStore({
  state: {},
  getters: {},
  mutations: {},
  actions: {},
  modules: {
    Auth,
  },
});
